
export default {
  mapForm: {
    'placesAndDirections': 'Buscar e ir',
    'isochrones': 'Alcanzar',
    'uploadedContentRendered': 'El contenido cargado está listo',
    'errorRenderingContentUploaded': 'Error al procesar el contenido cargado. Compruebe el formato y el contenido del archivo'
  }
}
